import { TPartialVersionedResource } from "app/queryProvider/interfaces";

export const reportsVersionedResource: TPartialVersionedResource<"telemonitoring-reports"> = {
  "telemonitoring-reports": {
    name: "telemonitoring-reports",
    version: "v1",
    microService: "patient",
    serializer: null,
  },
};

export const appointmentReportsVersionedResource: TPartialVersionedResource<"appointment-reports"> = {
  "appointment-reports": {
    name: "appointment-reports",
    version: "v1",
    microService: "patient",
    serializer: null,
  },
};
